
import { mapState } from 'vuex'

export default {
  computed: mapState('checkout', ['cart', 'licenses']),
  async created () {
    await this.$store.dispatch('checkout/fetchLicenses', { $backend: this.$backend })
  }
}

